import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求权限列表
export const getuserList = params => {
    return get("/admin/users", params);
};
// 分配用户
export const assignmentUser = params => {
    console.log(params.userParam)
    return put(`/admin/users/${params.id}/roles`, params.userParam);
};
// 添加用户
export const addUser = params => {
    return post("/admin/users", params);
};
// 删除用户
export const deleteUser = params => {
    return del(`/admin/users/${params}`);
};
// 修改信息
export const editUser = params => {
    return put(`/admin/users/${params.id}`, params);
};
// 修改自身密码
export const editmyPassword = params => {
    return put('/admin/users/profile', params);
};


// WEBPACK FOOTER //
// ./src/api/user.js